
"use client";

import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { HelpCircle } from "lucide-react";
import { ReactNode } from "react";

interface HelpTooltipProps {
    content: ReactNode;
    className?: string; // Allow custom styling for the trigger icon
}

export default function HelpTooltip({ content, className }: HelpTooltipProps) {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <button
                    className={`inline-flex items-center justify-center rounded-full text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 ${className}`}
                    aria-label="More information"
                >
                    <HelpCircle className="w-4 h-4 ml-1.5 cursor-help" />
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-80 text-sm leading-relaxed p-4 shadow-lg border-primary/20 bg-card text-card-foreground">
                <div className="font-semibold mb-1 text-primary flex items-center gap-2">
                    <HelpCircle className="w-4 h-4" />
                    How to interpret
                </div>
                {content}
            </PopoverContent>
        </Popover>
    );
}
